<template>
  <div class="grid-wrapper grid grid-cols-6 gap-y-8 gap-x-6 laptop:grid-cols-8 laptop:gap-y-10">
    <div
      class="col-span-6 mx-auto w-full max-w-[100%] tablet:max-w-[60%] laptop:col-span-3 laptop:mx-0 laptop:max-w-full"
    >
      <div class="relative flex h-0 items-center justify-center pt-[100%]" ref="panelContainer">
        <img
          class="opacity-1 absolute top-1/2 left-1/2 w-[150px] -translate-x-1/2 -translate-y-1/2 laptop:w-[200px]"
          src="/images/company/panel.png"
          alt=""
          ref="panel1"
        />
        <img
          class="opacity-1 absolute top-1/2 left-1/2 w-[150px] -translate-x-1/2 -translate-y-1/2 laptop:w-[200px]"
          src="/images/company/panel.png"
          alt=""
          ref="panel2"
        />
        <img
          class="opacity-1 absolute top-1/2 left-1/2 w-[150px] -translate-x-1/2 -translate-y-1/2 laptop:w-[200px]"
          src="/images/company/panel.png"
          alt=""
          ref="panel3"
        />
      </div>
    </div>
    <div class="col-span-6 col-start-1 flex flex-col laptop:col-span-3 laptop:col-start-6">
      <EnvironmentParagraphNextImages
        :title="data?.companyPage?.data?.attributes?.energy_title || ''"
        :text="data?.companyPage?.data?.attributes?.energy_description || ''"
        :alignRight="true"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useWaitForPageTransitionEnd } from "~~/composables/waitPageTransition";
import { Companypage2DataKey } from "~/symbols/symbols";
const data = inject(Companypage2DataKey);
const panel1 = ref<HTMLElement | null>(null);
const panel2 = ref<HTMLElement | null>(null);
const panel3 = ref<HTMLElement | null>(null);
const panelContainer = ref<HTMLElement | null>(null);

const { promise } = useWaitForPageTransitionEnd();

const tweens: Array<GSAPTween> = [];

onMounted(() => {
  initAnimation();
});
onBeforeUnmount(() => {
  tweens.forEach((tween) => tween.kill());
  tweens.length = 0;
});

async function initAnimation() {
  await promise.value;

  tweens.push(
    gsap.to(panel1.value, {
      scrollTrigger: {
        trigger: panelContainer.value,
        start: "top 90%",
        end: "center center",

        scrub: 2,
      },
      top: 0,
      yPercent: 0,
      opacity: 1,
    }),
  );

  tweens.push(
    gsap.to(panel2.value, {
      scrollTrigger: {
        trigger: panelContainer.value,
        start: "top 90%",
        end: "center center",
        scrub: 2,
      },
      left: 0,
      xPercent: 0,
      yPercent: -50,
      opacity: 1,
    }),
  );

  tweens.push(
    gsap.to(panel3.value, {
      scrollTrigger: {
        trigger: panelContainer.value,
        start: "top 90%",
        end: "center center",

        scrub: 2,
      },
      xPercent: -26,
      yPercent: -21,
      opacity: 1,
    }),
  );
}
</script>
<style lang="scss" scoped></style>
